import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ip_checkAdminAccess } from '../../lib/ip_admin_guard';
import { AdminProvider } from '../../contexts/AdminContext';
import LoadingScreen from '@/components/feature/LoadingScreen';

export function AdminGuard({ children }: { children: React.ReactNode }) {
  const [isChecking, setIsChecking] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAccess = async () => {
      const access = await ip_checkAdminAccess();
      if (!access.ok) {
        navigate('/admin/login', { replace: true });
      } else {
        setHasAccess(true);
      }
      setIsChecking(false);
    };
    checkAccess();
  }, [navigate]);

  if (isChecking) {
    return <LoadingScreen />;
  }

  if (!hasAccess) {
    return null;
  }

  return <AdminProvider>{children}</AdminProvider>;
}

export default AdminGuard;